// extracted by mini-css-extract-plugin
export default {"selector":"Nr2eptb_IZGBDKRO5SAd","selected":"sOgLtpx80lkZwfjDQcnt"};